import { styled } from '@mui/material'

export const Separator = styled('div')(() => ({
  width: '1fr',
  flexGrow: '1',
  borderTop: '0.5px dashed #E3E6E3',
  alignSelf: 'center',
  marginTop: '2px'
}))
